import { api } from './api';

const loadBalanceDetailsGetPagedList = async (data, pageNumber, pageSize) => {
  const response = await api({
    url: `LoadBalanceDetails/getPagedList?Page=${pageNumber}&PageSize=${pageSize}`,
    method: 'POST',
    data: data,
  });
  return response.data;
};

const getAllLoadBalanceCards = async ({ loadBalanceId, customerId, vouId = 1 }) => {
  const response = await api({
    url: `LoadBalanceDetails/getPagedList`,
    method: 'POST',
    data: {
      loadBalanceId,
      Page: 0,
      PageSize: 0,
      customerId,
      vouId,
    },
  });
  return response.data;
};

const getCurrentEmployeeList = async ({
  loadBalanceId,
  customerId,
  showOnlyPriced,
  vouId,
  pageNumber,
  pageSize,
}) => {
  const response = await api({
    url: `gifts/getCurrentEmployeeList`,
    method: 'POST',
    data: {
      loadBalanceId,
      Page: pageNumber,
      PageSize: pageSize,
      customerId,
      showOnlyPriced,
      vouId,
    },
  });
  return response.data;
};

const loadBalanceDetailsGetPagedDtoList = async (data, pageNumber, pageSize) => {
  const response = await api({
    url: `LoadBalanceDetails/getPagedDtoList?Page=${pageNumber}&PageSize=${pageSize}`,
    method: 'GET',
    params: data,
  });
  return response.data;
};

const updateLoadBalanceDetailPrice = async (data) => {
  const response = await api({
    url: `LoadBalanceDetails/updateLoadBalanceDetailPrice`,
    method: 'POST',
    data,
  });
  return response.data;
};

const loadBalanceDetailUpdate = async (data) => {
  const response = await api({
    url: `LoadBalanceDetails`,
    method: 'PUT',
    data,
  });
  return response.data;
};

const loadBalanceDetailExcelTemplate = async (data) => {
  const response = await api({
    url: `LoadBalanceDetails/loadBalanceDetailExcelTemplate`,
    method: 'POST',
    data,
    responseType: 'blob',
  });
  return response.data;
};

const loadBalanceDetailExcelUpload = async (data) => {
  const response = await api({
    url: `LoadBalanceDetails/loadBalanceDetailExcelUpload`,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  });
  return response.data;
};

const loadBalancePopUpMessage = async (data) => {
  const response = await api({
    url: `LoadBalanceDetails/popUpMessageLoadBalance`,
    method: 'POST',
    data,
  });
  return response.data;
};
const postBalanceTransferReport = async (data) => {
  const response = await api({
    url: `BalanceTransfers/GetBalanceTransferReport`,
    method: 'POST',
    data,
  });
  return response.data;
};

const balanceTrasferReportGetExcelFile = async (data) => {
  const response = await api({
    url: `BalanceTransfers/GetBalanceTransferReportFile`,
    method: 'POST',
    responseType: 'arraybuffer',
    data,
  });
  return response.data;
};

const balanceTrasferReportGetPDFFile = async (data) => {
  const response = await api({
    url: `Report/GetBalanceTransferReportPdfFile`,
    method: 'POST',
    responseType: 'arraybuffer',
    data,
  });
  return response.data;
};

const postLoadBalancesReport = async (data) => {
  const response = await api({
    url: `LoadBalances/getLoadBalancesReport`,
    method: 'POST',
    data,
  });
  return response.data;
};

const loadBalancesReportGetExcelFile = async (data) => {
  const response = await api({
    url: `LoadBalances/DownloadLoadBalancesReportFile`,
    method: 'POST',
    responseType: 'arraybuffer',
    data,
  });
  return response.data;
};

const loadBalancesReportGetPDFFile = async (data) => {
  const response = await api({
    url: `Report/GetLoadBalancesReport`,
    method: 'POST',
    responseType: 'arraybuffer',
    data,
  });
  return response.data;
};

const balanceUploadDetailServices = {
  loadBalanceDetailUpdate,
  loadBalanceDetailsGetPagedList,
  updateLoadBalanceDetailPrice,
  loadBalanceDetailExcelUpload,
  loadBalanceDetailExcelTemplate,
  loadBalancePopUpMessage,
  loadBalanceDetailsGetPagedDtoList,
  getAllLoadBalanceCards,
  postLoadBalancesReport,
  loadBalancesReportGetExcelFile,
  loadBalancesReportGetPDFFile,
  postBalanceTransferReport,
  balanceTrasferReportGetExcelFile,
  balanceTrasferReportGetPDFFile,
  getCurrentEmployeeList,
};

export default balanceUploadDetailServices;
